import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Reads every markup anchored to one target, ordered by `sequenceNumber` asc.
 *
 * `targetContext` is nullable in the SDL but **mandatory for `PlanPage`** — the server answers
 * `VALIDATION` without `planVersionId`, so callers always pass it (Markup contract §1, §3.4).
 *
 * The result is deliberately unpaginated: the set is page-scoped and bounded by human drawing
 * capacity (contract §1, ruled 2026-09-01).
 *
 * The selection set is `MARKUP_FIELDS`, shared with `CREATE_MARKUP` and `UPDATE_MARKUP` (KD-9):
 * `MarkupsResponse` (`@efficiently/client-api-plans`) is derived from this query's row and the two
 * mutations must answer with the same one.
 */
export const GET_MARKUPS = gql(`
	query Markups(
		$projectId: ID!
		$targetType: MarkupTargetType!
		$targetId: ID!
		$targetContext: MarkupTargetContext
	) {
		markups(
			projectId: $projectId
			targetType: $targetType
			targetId: $targetId
			targetContext: $targetContext
		) {
			...MarkupFields
		}
	}
`);
